export const AGREE_TO_TERMS = 'AGREE_TO_TERMS';

export const agreeToTerms = () => ({ type: AGREE_TO_TERMS, payload: true })